import { sesHealth } from '@/services/sesHealth.service'

export default {
	namespaced: true,
	state: {
		snapshot: null,
		status: 'init',
		error: null,
	},
	getters: {
		getSnapshot(state) {
			return state.snapshot
		},
		getStatus(state) {
			return state.status
		},
		getError(state) {
			return state.error
		},
		getAlerts(state) {
			return state.snapshot?.alerts ?? []
		},
		hasCriticalAlert(state) {
			return (state.snapshot?.alerts ?? []).some(alert => alert.level === 'critical')
		},
	},
	mutations: {
		SET_SNAPSHOT(state, value) {
			state.snapshot = value
		},
		SET_STATUS(state, value) {
			state.status = value
		},
		SET_ERROR(state, value) {
			state.error = value
		},
	},
	actions: {
		async fetchSnapshot({ commit }, fresh = false) {
			commit('SET_STATUS', 'pending')
			commit('SET_ERROR', null)
			try {
				const { data } = await sesHealth(fresh)
				commit('SET_SNAPSHOT', data.data)
				commit('SET_STATUS', 'init')
				return data.data
			} catch (error) {
				// A failure here means the endpoint itself is unreachable. A
				// missing AWS credential does not land here — that comes back
				// as a normal payload with aws_available false.
				commit('SET_ERROR', error?.response?.data?.message ?? error.message)
				commit('SET_STATUS', 'init')
				throw error
			}
		},
	},
}
